import { render, staticRenderFns } from "./MessageThreadsSort.vue?vue&type=template&id=034758e4&scoped=true&"
import script from "./MessageThreadsSort.vue?vue&type=script&lang=ts&"
export * from "./MessageThreadsSort.vue?vue&type=script&lang=ts&"
import style0 from "./MessageThreadsSort.vue?vue&type=style&index=0&id=034758e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034758e4",
  null
  
)

export default component.exports